import React, { Component } from "react";
import { makeID } from "./helper";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
require("firebase/functions");


class Login extends Component {
  state = {
    email: "",
    password: "",
    error: "",
    logged: false
  };

  render() {
    return (
      <React.Fragment>
        <form>
        <div className="jumbotron mt-3">
            <h1>Tajemství Vladanova Rodu</h1>
          </div>
          <div className="form-group">
            <label htmlFor="email-login">Emailová adresa</label>
            <input
              type="email"
              className="form-control"
              id="email-login"
              aria-describedby="emailHelp"
              onChange={this.handleEmailChange}
              value={this.state.email}
              placeholder="vložte Váš email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="current-password">Heslo</label>
            <input
              type="password"
              className="form-control"
              id="current-password"
              placeholder="heslo"
              onChange={this.handlePasswordChange}
              value={this.state.password}
            />
          </div>

          {this.renderHlaseni()}

          <button onClick={this.handleLogin} className="btn btn-primary">
            Začít hru
          </button>
        </form>
        <div className="navbar fixed-bottom  footer">ver 1.1.2</div>
      </React.Fragment>
    );
  }

  renderHlaseni = () => {
    if (this.state.error.length !== 0)
      return <div className="alert alert-danger">{this.state.error}</div>;
    else return null;
  };

  handleEmailChange = evt => {
    this.setState({ email: evt.target.value });
  };

  handlePasswordChange = evt => {
    this.setState({ password: evt.target.value });
  };

  handleLogin = event => {
    const { email, password } = this.state;

    //const { history } = this.props;

    //console.log("Prihlaseni uzivatele", this.state.email, this.state.password);
    event.preventDefault();

    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      //.then(() => this.setState({ logged: true }))
      .then(() => {
        this.onGoodLogin();
        //this.mailTest();
      })
      .catch(error => {
        // Handle Errors here.
        var errorCode = error.code;
        //var errorMessage = error.message;
        //this.setState({ logged: false });
        //this.setState({ error: errorMessage });
        if (errorCode === "auth/invalid-email")
          this.setState({ error: "Chybný email" });
        if (errorCode === "auth/wrong-password")
          this.setState({ error: "Chybný email / heslo" });
        //console.log("Chyba prihlasovani code", errorCode, errorMessage, this);
      });

    // auth
    //   .doSignInWithEmailAndPassword(email, password)
    //   .then(() => {
    //     this.setState({ logged: true });
    //     console.log("Uspesne prihlaseni");
    //     //history.push(routes.HOME);
    //   })
    //   .catch(error => {
    //     console.log("Chyba pri prihlaseni", error);
    //     //this.setState(byPropKey("error", error));
    //   });
    //};
  };

  // jen testovaci
  // mailTest = () => {
  //   console.log("Volam mailtest");
  //   console.log("Funkce" + firebase.functions());
  //   var addMessage = firebase.functions().httpsCallable("sendMail");
  //   addMessage({ text: "messageText" }).then(function(result) {
  //     // Read result of the Cloud Function.
  //     //var sanitizedMessage = result.data.text;
  //     console.log("Vysledek volani" + result);
  //   });
  //   console.log("konec mailtestu");
  // };

  onGoodLogin = () => {
    var user = firebase.auth().currentUser;
    //console.log("Prihlaseno on good login", user);

    //var err = "";
    //this.props.onLogin();

    //Odkomentovat!!! pro skutecny provoz
    firebase
      .database()
      .ref("Hry/" + makeID(user))
      .once("value", snapshot => {
        if (snapshot.val() == null) {
          //console.log("Writing user data");
          this.writeUserData();
          this.props.onLogin();
        } else if (snapshot.val().dokonceno === true) {
          //console.log("Hrajete již dokončenou hru !");
          this.props.onLogin("dohrano");
          this.setState({
            error: "Již dohráno s časem: " + snapshot.val().cas
          });
        } else this.props.onLogin();
        //console.log("Prectena data", snapshot.val());
      });
  };

  // makeID = user => {
  //   let vysledek = user.email.replace("@", "(at)").replace("/./g", "(tecka)");
  //   console.log(vysledek);
  //   return vysledek;
  // };

  writeUserData = () => {
    const { email } = this.state;
    let start = Date.now();
    var user = firebase.auth().currentUser;

    var now = new Date();
    var todayUTC = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      )
    );
    var cas = todayUTC.toISOString();
    //var user = firebase.auth().currentUser;

    firebase
      .database()
      .ref("Hry/")
      .child(makeID(user))
      .update({
        email,
        start,
        zacatek: cas,
        krok: 0
      })
      .then(data => {
        //success callback
        console.log("data ", data);
      })
      .catch(error => {
        //error callback
        console.log("error ", error);
      });
  };
}

export default Login;
